module.exports = __webpack_public_path__ + "img/background-branch-detail.fa30e0c4.svg";